import React from 'react';
import { NavLink } from "react-router-dom";
import CartButton from './CartButton';
import { connect } from 'react-redux';
import { addToCart } from './actions/';
import styles from './assets/styles/main.css';

const products = [
	{
        id: 1,
        name: 'T shirt 1',
        price: 70,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 2,
        name: 'T shirt 2',
        price: 40,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 3,
        name: 'T shirt 3',
        price: 20,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    },
    {
        id: 4,
        name: 'T shirt 4',
        price: 130,
        description: 'Lorem ipsum dolar sit amet',
        image: 'https://via.placeholder.com/220'
    }
];





class ProductCard extends React.Component{



	handleClick = (id) => {
		this.props.addToCart(id)
	}


	renderedProducts = products.map((product) => {
		return(

				<div className = 'col-lg-4 productCard' key = {product.id}>
					<NavLink to = {`/SingleProduct/?id=${product.id}`}>
						<img className = 'productCardImage' src = {product.image} />
					</NavLink>
					<h3 className = 'productCardName'>{product.name}</h3>
					<h5>{`$${product.price}`}</h5>
					<CartButton clickHandler = {() => {this.handleClick(product.id)}}/>
				</div>

			);
	});

	render(){
		return (
			<div className = 'row'>
				{this.renderedProducts}
			</div>
				);		
	}


};

const mapDispatchToProps= (dispatch)=>{
    return{
        addToCart: (id)=>{dispatch(addToCart(id))}
    }
}

export default connect(null, mapDispatchToProps)(ProductCard)